export enum CatchAll {
  ByFile = 1,
  ByRoom,
  BySchedule,
  ByAutoAssign = 4
}
